import React, { useEffect, useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { pDialogProfileTab } from "../../utils/parameters";
import { Button } from '@mui/material';
import { Paper } from "@material-ui/core";
import { pDB_user_roles } from "../../utils/parameters";
import { DialogInfoProfile } from "../accountDialog_content_views/DialogInfoProfile";
import { DialogEditProfile } from "../accountDialog_content_views/DialogEditProfile";
import { DialogConfiguration } from "../accountDialog_content_views/DialogConfiguration";
import { useDataProvider } from "../../api/DataProvider";
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip, withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import "../../styles/devices/mob_UserProfile.css";
import { useCommProvider } from "../../api/CommProvider";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AvatarUploadImage from "../utils/AvatarUploadImage";



import { SignaPointsDialog } from "./SignaPointsDialog";
import { useTranslation } from "react-i18next";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    maxWidth: '500px',
    fontSize: '15px',
    backgroundColor: '#d0e6fa',
    padding: '15px',
    border: '1px solid #fff',
    color: 'black',
    borderRadius: '5px'
  },
}))(Tooltip);

export function AccountDialog(props) {

  const { t } = useTranslation("global")
  const { openDialog, setOpenDialog } = props;
  const [ tabValue, setTabValue ] = useState(0);
  const { json_data_USER, set_json_data_USER, currentUserRole, token_id, currentUser } = useDataProvider();
  const { comm_updateProfile } = useCommProvider();
  const [ profileData, setProfileData ] = useState({});
  const [ openDialogSignaPoints, setOpenDialogSignaPoints ] = useState(false);

  // Control
  const [ profileModified, setProfileModified ] = useState(false);
  const [ showWarningModal, setShowWarningModal ] = useState(false);
  const [ saveAndClose, setSaveAndClose ] = useState(false);

  const [ totalSignaPoints, setTotalSignaPoints ] = useState('?')

  const handleClose = () => {
    if (!profileModified) {
      setOpenDialog(false);
      setTabValue(pDialogProfileTab.info);
      setShowWarningModal(false);
      setSaveAndClose(false);
    } else {
      setShowWarningModal(true);
    }
  };

  const handleCloseWithoutSaving = () => {
    setProfileModified(false);
    setOpenDialog(false);
    setTabValue(pDialogProfileTab.info);
    setShowWarningModal(false);
  };

  const handleSaveClose = () => {
    setSaveAndClose(true);
    setShowWarningModal(false);
  };

  useEffect(() => {
    if (json_data_USER !== undefined && json_data_USER !== null){
      setProfileData({
        'imgBase64': json_data_USER['profile']['imgBase64'] === undefined ? '' : json_data_USER['profile']['imgBase64'],
        'email': json_data_USER['email'] === undefined ? '' : json_data_USER['email'],
        'role': json_data_USER['role'] === undefined ? '' : json_data_USER['role'],
        'isPublic': json_data_USER['profile']['isPublic'] === undefined ? '' : json_data_USER['profile']['isPublic'],
        'name': json_data_USER['profile']['name'] === undefined ? '' : json_data_USER['profile']['name'],
        'sex': json_data_USER['profile']['sex'] === undefined ? '' : json_data_USER['profile']['sex'],
        'age': json_data_USER['profile']['age'] === undefined ? '' : json_data_USER['profile']['age'],
        'zip_code': json_data_USER['profile']['zip_code'] === undefined ? '' : json_data_USER['profile']['zip_code'],
        'address': json_data_USER['profile']['address'] === undefined ? '' : json_data_USER['profile']['address'],
        'level': json_data_USER['profile']['level'] === undefined ? '' : json_data_USER['profile']['level'],
        'school': json_data_USER['profile']['school'] === undefined ? '' : json_data_USER['profile']['school'],
        'arr_teams': json_data_USER['arr_teams'] === undefined ? [] : json_data_USER['arr_teams'],
        'signapoints': {'score' : 0}
      })
    }
  }, [json_data_USER]);

  // const profile_updated = await comm_updateProfile(token_id, currentUser, changedFields);

  async function update_ImageAccount(imgBase64){
    const update_data = {
        'imgBase64':imgBase64
    }
    const profile_updated = await comm_updateProfile(token_id, currentUser, update_data);
    set_json_data_USER({ ...json_data_USER, profile: profile_updated });
    console.log("🚀 ~ file: AccountDialog.js:107 ~ update_ImageAccount ~ profile_updated:", profile_updated)
  }


  // useEffect(() => {
  //   console.log("🚀 ~ file: AccountDialog.js:129 ~ AccountDialog ~ openDialog:", openDialog)

  //   async function updateSignamedPoints(){
  //     console.log("🚀 ~ file: AccountDialog.js:120 ~ updateSignamedPoints ~ updateSignamedPoints:", updateSignamedPoints)
  //     setProfileData({
  //       ...profileData,
  //         'signapoints': await comm_getReportActivity(token_id, currentUser)
  //       })
  //   }
  //   if (openDialog === true) {
  //     if (Object.keys(profileData).length > 0) {  // Si profileData no está vacío
  //       updateSignamedPoints();
  //     }
  //   }
  // }, [openDialog]);


  // useEffect(() => {
  //   console.log("🚀 ~ file: AccountDialog.js:74 ~ AccountDialog ~ profileData:", profileData)
  // }, [profileData]);

  const showSignamedPointsReport = () => {
    if (profileData['signapoints'] !== undefined){
      return <TableContainer component={Paper}>
              <Table className="custom-table" aria-label="customized table">
                <TableHead>
                    <TableRow>
                      <TableCell className="table-header" colSpan={2} align="center"> <span> <strong>SignaPoints: </strong> {profileData['signapoints']['score']} </span> </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell className="table-cell"> <strong>Búsquedas LSE</strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {profileData['signapoints']['INFERENCE']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong>Colaboraciones</strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {profileData['signapoints']['COLLABORATION']} </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="table-cell"> <strong>Dona Signo</strong> </TableCell>
                      <TableCell className="table-cell" align="center"> {profileData['signapoints']['DONATE_SIGN']} </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
            </TableContainer>
    }else{
      return "Data no disponible"
    }
  }
  

  return (
    <>
      {currentUserRole !== pDB_user_roles.invitated ? 
        <>
          <Dialog className='sig_Drawer_SettingsModal_Root sig_Account_Modal_Root' open={openDialog} onClose={handleClose}>
            <DialogTitle className='sig_Drawer_SettingsModal_Title' > {t("sProfile.myAccount").toUpperCase()} </DialogTitle>
            <div className="sig_Account_Header">              
              {/* <div className="sig_Profile_Avatar">
                <Avatar alt="User profile picture" src={profileData['img_user']} className="sig_Profile_circular_img" />
              </div> */}

              <AvatarUploadImage image={profileData['imgBase64']} editable={tabValue === pDialogProfileTab.edit} handleSendImage={update_ImageAccount}/>

              <div className='sig_SignModal_PaperLine'>
                {
                  (profileData['name'] === '' || profileData['isPublic'] === false) 
                  ? <div className="sig_Account_Header_Name"> {currentUser.uid} </div>
                  : <>
                    <div className="sig_Account_Header_Name"> {profileData['name']} </div>
                    <div className="sig_Account_Header_Role"> [ {currentUser.uid} ] </div>
                    </> 
                }
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_Account_Header_Role">{ profileData['role'] }</div>
              </div>
              {/* <CustomTooltip interactive={true} placement="top" title={showSignamedPointsReport()} enterTouchDelay={0}> */}

              {/* <CustomTooltip ref={signaPointsRef} placement="top" title={showSignamedPointsReport()}>
                <div className='sig_SignModal_PaperLine sig_Account_Header_Points'>
                    <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline">{t("sProfile.signamedpoints")}</div>
                    <div className="sig_SignModal_PaperBody"> { (profileData['signapoints'] !== undefined) ?  profileData['signapoints']['score'] : 0 } </div>
                </div>
              </CustomTooltip> */}

              <Button style={{margin:'auto', borderRadius: '10px', width: '300px', backgroundColor: '#5ea0d4'}} onClick={() => setOpenDialogSignaPoints(true)}>
                <div className='sig_SignModal_PaperLine sig_Account_Header_Points'>
                    <div className="sig_SignModal_PaperTitle sig_SignModal_Paper_Title_Body_Inline">{t("sProfile.signamedpoints")}</div>
                    <div className="sig_SignModal_PaperBody"> { totalSignaPoints } </div>
                </div>
              </Button>
              <SignaPointsDialog openDialog={openDialogSignaPoints} setOpenDialog={setOpenDialogSignaPoints} setTotalSignaPoints={setTotalSignaPoints} type={'GLOBAL'} target={currentUser.uid}/>

            </div>
              <div className="sig_Account_MenuContainer sig_Home_HideScrollBar">
                <Tooltip title={t("sTooltip.information")} placement="bottom" arrow>
                  <div className={`sig_Main_IconButton ${tabValue === pDialogProfileTab.info ? 'sig_Main_IconButtonActive' : ''}`} onClick={() => setTabValue(pDialogProfileTab.info)}>
                    <PersonIcon className="sig_Home_ChangeOnDarkMode"/>
                  </div>
                </Tooltip>
                <Tooltip title={t("sTooltip.edit")} placement="bottom" arrow>
                  <div className={`sig_Main_IconButton ${tabValue === pDialogProfileTab.edit ? 'sig_Main_IconButtonActive' : ''}`} onClick={() => setTabValue(pDialogProfileTab.edit)}>
                    <EditIcon className="sig_Home_ChangeOnDarkMode"/>
                  </div>
                </Tooltip>
                <Tooltip title={t("sTooltip.settings")} placement="bottom" arrow>
                  <div className={`sig_Main_IconButton ${tabValue === pDialogProfileTab.configuration ? 'sig_Main_IconButtonActive' : ''}`} onClick={() => setTabValue(pDialogProfileTab.configuration)}>
                    <SettingsIcon className="sig_Home_ChangeOnDarkMode"/>
                  </div>
                </Tooltip>
              </div>    
              <DialogContent className='sig_Drawer_SettingsModal_Content sig_Account_TabContainer'>
                {tabValue === pDialogProfileTab.info && <DialogInfoProfile profileData={profileData}/>}
                {tabValue === pDialogProfileTab.edit && <DialogEditProfile setTabValue={setTabValue} profileData={profileData} setProfileData={setProfileData} profileModified={profileModified} setProfileModified={setProfileModified} saveAndClose={saveAndClose} setSaveAndClose={setSaveAndClose}/>}
                {tabValue === pDialogProfileTab.configuration && <DialogConfiguration/>}
              </DialogContent>
              <DialogActions className="sig_FormDialog_Button">
                <Button onClick={handleClose}> {t("strButton.btn_exit")} </Button>
              </DialogActions>
          </Dialog>
        </>
      :
      <>
        <Dialog className='sig_Drawer_SettingsModal_Root' open={openDialog} onClose={handleClose}>
            <DialogTitle className='sig_Drawer_SettingsModal_Title' > {t("sProfile.myAccount").toUpperCase()} </DialogTitle>
            <Paper className="sig_SignModal_PaperContent">
              <div className='sig_SignModal_PaperInfo'>
                <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle"> {t("sProfile.invitated_title")} </div>
                  <hr></hr>
                  <div className="sig_SignModal_PaperBody"> {t("sProfile.invitated_body")} </div>
                </div>
              </div> 
            </Paper>


            <DialogActions className="sig_FormDialog_Button">
              <Button onClick={handleClose}> {t("strButton.btn_exit")} </Button>
            </DialogActions>
        </Dialog>
      </>
      }

      { showWarningModal ? 
        <>
        <Paper className="sig_SignModal_PaperContent sig_Account_WarningContent">
          <div className='sig_SignModal_PaperInfo sig_Account_WarningInfo'>
            <div className='sig_SignModal_PaperLine'>
              <div className="sig_SignModal_PaperTitle"> {t("sProfile.warning")} </div>
              <div className="sig_SignDialog_Button">
                <Button onClick={handleSaveClose}><SaveIcon className="sig_Account_Icon"/> {t("strButton.btn_save_exit")} </Button>
              </div>
              <div className="sig_SignDialog_Button">
                <Button onClick={handleCloseWithoutSaving}><CloseIcon className="sig_Account_Icon"/> {t("strButton.btn_no_save_exit")} </Button>
              </div>
            </div>
          </div> 
        </Paper>
        </> 
      : 
        <>
        </>
      }
    </>
  );
}